"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getAsyncCallback(device, logger) {
  switch (device) {
    case 'and':
      return value => {
        const valueString = JSON.stringify(value);

        try {
          // eslint-disable-next-line no-undef
          promoapp.message(valueString);
        } catch (error) {
          logger.warn('promoapp.message is missing');
        }
      };

    case 'ios':
      return value => {
        const valueString = JSON.stringify(value);

        try {
          window.webkit.messageHandlers.promoapp.postMessage(valueString);
        } catch (error) {
          logger.warn('window.webkit.messageHandlers.promoapp is missing');
        }
      };

    default:
      return value => {
        logger.info('device was not set, message was not sent, message:', value);
      };
  }
}

var _default = getAsyncCallback;
exports.default = _default;